import React, { Component } from 'react';
import { Field, reduxForm,  formValueSelector } from 'redux-form';
import { renderSelectCustom, modalCurrency, renderCurrency } from 'Utils/renderField/renderField';

export const renderCardRow =({ fields, cards, meta: {error, submitFailed}, edit, view}) => (

    <React.Fragment>
        {
            fields.map((field, index) => (
                <tr key={index} >
                    <td className="d-none">
                    <Field
                        component="input"
                        name={`${field}.id`}
                        type="hidden"
                    />
                    </td>
                    <td>
                        <Field
                            disabled={false}
                            name={`${field}.amount`}
                            component={modalCurrency}
                            type="text"
                            className="form-control"
                        />
                    </td>
                    <td>
                        <Field
                            name={`${field}.cards`}
                            valueKey="value"
                            labelKey="label"
                            label="name"
                            component={renderSelectCustom}
                            options={cards}
                            className="no-border"
                            disabled={false}
                        />
                    </td>
                    <td className="text-center">
                        <img className="action-img delete-button-r2"
                            src={require("../../../../../assets/img/icons/delete-icon.png")}
                            onClick={() => {fields.remove(index)}}
                            alt="Eliminar" />
                    </td>
                </tr>
                )
            )
        }
                <tr id="add-row">
                    <td colSpan={2}></td>
                    <td className="text-center">
                            <img onClick={() => fields.push()} className="action-img add-button-r2" src={require("../../../../../assets/img/icons/add-icon.png")} alt="Agregar" />
                    </td>
                </tr>
        {/* row for the add button */}
        {
            submitFailed && (
                <div className="invalid-feedback d-flex justify-content-center">
                    {error}
                </div>
            )
        }
    </React.Fragment>
);
